import { select, takeEvery } from "redux-saga/effects"
import { get, pick } from "lodash"
import { Types } from "../../actions/app/history"

export function sendIdentify(state) {
  const { user } = state

  if (!user?.id) return

  const account = {
    id: get(state, "global.selected.accountId"),
    ...pick(get(state, "global.selected.accountMeta"), ["alias", "name", "applications"]),
  }
  const { id, alias, name } = account

  // dont add superusers to segment groups
  if (!user.isSuperuser && id != null) {
    window.analytics.group(id, account)
  }

  // Always identify so Segment → Mixpanel get $name/$email (replay display name, event
  // attribution). Attach the Intercom HMAC only when idHash is present, so a missing hash
  // degrades Intercom gracefully instead of suppressing identity entirely. See APP-3222.
  const identifyOptions = user.idHash ? { Intercom: { user_hash: user.idHash } } : undefined

  window.analytics.identify(user.id, {
    name: user.name,
    email: user.email,
    isSuperuser: user.isSuperuser,
    accountValue: alias,
    accountName: name,
    __akita_organization_name_property: "account_name",
    __akita_organization_id_property: "account_value",
  }, identifyOptions)

  // Intercom's verified-user state doesn't refresh from Segment identify alone
  // when post-login routing uses { replace: true } (no page() call fires).
  if (window.Intercom && user.idHash) {
    window.Intercom("update", { user_hash: user.idHash })
  }
}

export function sendPage() {
  window.analytics.page()
}

export function* callAnalyticsEvent(action) {
  const { type, initial, location: locationAction } = action

  if (type === Types.IDENTIFY) {
    yield select(sendIdentify)
  } else if (!initial && locationAction?.action !== "REPLACE") {
    yield select(sendPage)
  }
}

export default function* () {
  yield takeEvery([Types.IDENTIFY, Types.NAVIGATE], callAnalyticsEvent)
}
